import {Component, Input} from '@angular/core';
import {DatasetUsageComponentObject} from "../../../../shared/classes/dataset-usage-component-object";

@Component({
  selector: 'app-custom-sources-badge-metrics',
  templateUrl: './custom-sources-badge-metrics.component.html',
  styleUrls: ['./custom-sources-badge-metrics.component.scss']
})
export class CustomSourcesBadgeMetricsComponent {
  @Input() public datasource: DatasetUsageComponentObject;
}
